module.exports = __webpack_public_path__ + "static/img/Simple_Heptagonal_Set_1-15-512.c3f4aff6.png";